<template>
  <section class="developerInfo">
    <!--头部开始-->
    <v-developer-header></v-developer-header>
    <!--头部结束-->

    <div class="developer-info-content">
      <div class="form-content">
        <form class="form-controll" action="javascript: void(0)" @submit.prevent="validateBeforeSubmit">
          <dl class="form-item clearfix">
            <dt class="title">您的姓名：</dt>
            <dd class="content">
              <input name="user" type="text" v-model="formDatas.userName" placeholder="您的姓名" v-validate="'required|max:20'" />
              <div class="form-tips form-error-tips" v-show="errors.has('user')">
                <i class="icon"></i>
                <i class="icon-error-tips"></i>
                <span class="text">{{ errors.first('user') }}</span>
              </div>
            </dd>
          </dl>

          <dl class="form-item clearfix">
            <dt class="title">您的邮箱：</dt>
            <dd class="content">
              <input name="email" type="text" v-model="formDatas.email" placeholder="Email" v-validate="'required|email|max:50'"  />
              <div class="form-tips form-error-tips" v-show="errors.has('email')">
                <i class="icon"></i>
                <i class="icon-error-tips"></i>
                <span class="text">{{ errors.first('email') }}</span>
              </div>
            </dd>
          </dl>

          <dl class="form-item clearfix">
            <dt class="title">您的手机号：</dt>
            <dd class="content">
              <input name="phone" type="tel" v-model="formDatas.mobile" placeholder="请输入手机号" v-validate="'required|phone'" @focus="codeErrorTips = ''" />

              <div class="check-code-box">
                <a class="check-code-btn" href="javascript: void(0)" @click="getCode" :disabled="!sendCodeshow" v-show="sendCodeshow">发送验证码</a>
                <span class="check-code-btn" onselectstart="return false" v-show="!sendCodeshow">{{codeTimeCount}} s 后再次发送</span>

              </div>

              <div class="form-tips form-error-tips" v-show="codeErrorTips">
                <i class="icon"></i>
                <i class="icon-error-tips"></i>
                <span class="text">{{ codeErrorTips }}</span>
              </div>

              <div class="form-tips form-error-tips" v-show="errors.has('phone')">
                <i class="icon"></i>
                <i class="icon-error-tips"></i>
                <span class="text">{{ errors.first('phone') }}</span>
              </div>
            </dd>
          </dl>

          <dl class="form-item clearfix">
            <dt class="title">验证码：</dt>
            <dd class="content">
              <input type="text" v-model="formDatas.checkCode" @focus="codeFlag = false" />
              <div class="form-tips form-error-tips" v-show="codeFlag">
                <i class="icon"></i>
                <i class="icon-error-tips"></i>
                <span class="text">{{ errorTips }}</span>
              </div>
            </dd>
          </dl>
        </form>
      </div>

      <!--提交开始-->
      <div class="handle">
        <div class="handle-btn-wrap">
          <a class="handle-btn" href="javascript: void(0)" @click="successFn">完成</a>
        </div>
      </div>
      <!--提交结束-->
    </div>
  </section>
</template>

<script type="text/ecmascript-6">
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 开发者申请头部组件
  import developerHeader from 'components/developerHeader/developerHeader'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 发送验证码倒计时
  const TIME_COUNT = 120
  // 错误提示
  const ERROR_TIPS = [
    { desc: '网络错误' },
    { desc: '验证码错误' }
  ]

  export default {
    // 开发者申请信息填写页面
    name: 'developerInfo',
    data () {
      return {
        // 验证码错误提示
        codeFlag: false,
        // 是否勾选协议
        checkBoxFlag: false,
        // 发送请求开关
        sendFlag: true,
        // 发送验证码按钮开关
        sendCodeshow: true,
        // 验证码倒计时变量
        codeTimeCount: '',
        // 计时器变量
        codeTimer: null,
        // 验证码错误信息
        codeErrorTips: '',
        // 错误提示
        errorTips: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID'),
          // 申请开发者姓名
          userName: '',
          // 邮箱
          email: '',
          // 手机
          mobile: '',
          // 验证码
          checkCode: ''
        }
      }
    },
    methods: {
      successFn () {
        // 验证表单是否有错误
        this.$validator.validateAll().then(() => {
          // 表单有错误返回 true 没错误返回 false
          // console.log(this.errors.any())
          // 返回所有错信的信息列表
          // console.log(this.errors.all())
          // 检测表单中是否有验证错误
          let validateRes = this.errors.any()

          if (validateRes) {
            // 错误信息
            this.errorTips = ERROR_TIPS[1].desc
            // 显示错误信息
            this.codeFlag = true
          } else {
            if (this.sendFlag) {
              // 关闭发送请求按钮
              this.sendFlag = false
              // 实例化表单对象
              let formData = new FormData()
              // 用户id
              formData.append('UserID', this.formDatas.userId)
              // sessionId
              formData.append('SessionID', this.formDatas.sessionId)
              // 用户名
              formData.append('RealName', this.formDatas.userName)
              // 邮箱
              formData.append('Email', this.formDatas.email)
              // 手机
              formData.append('Mobile', this.formDatas.mobile)
              // 验证码
              formData.append('VerificationCode', this.formDatas.checkCode)
              // 申请开发者 api
              Axios.post(`${this.$api.root}/Developer/DeveloperApply`, formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then((response) => {
                // http 请求成功
                if (response.status === 200) {
                  // 获取接口数据
                  let res = response.data
                  switch (res.Code) {
                    // 申请成功跳转到申请状态页面
                    case 0:
                      this.$router.push({name: 'developerStatus'})
                      break
                    // 登录信息失效，删除登录信息跳转到登录页
                    case 1:
                      delUserCookie()
                      this.$router.push({name: 'login'})
                      break
                    case 2:
                      // 错误信息
                      this.errorTips = res.Msg
                      // 显示错误信息
                      this.codeFlag = true
                      // 开启发送请求按钮
                      this.sendFlag = true
                      break
                    // 请求失败
                    default:
                      // 错误信息
                      this.errorTips = res.Msg
                      this.codeFlag = true
                      // 开启发送请求按钮
                      this.sendFlag = true
                  }
                } else {
                  // 开启发送请求按钮
                  this.sendFlag = true
                }
                // 请求接口失败
              }).catch((error) => {
                // 开始发送请求按钮
                this.sendFlag = true
                // 打印请求失败信息
                console.log(error)
              })
            }
          }
        }).catch(() => {
          console.log('表单验证失败')
        })
      },
      // 发送验证后倒计时
      getCode () {
        this.$validator.validate('phone', this.formDatas.mobile)
        // 检测手机号是否正确
        let mobileCheck = this.errors.any()
        console.log(mobileCheck)
        if (!mobileCheck) {
          // 实例化表单对象
          let formData = new FormData()
          // 用户id
          formData.append('UserID', this.formDatas.userId)
          // sessionId
          formData.append('SessionID', this.formDatas.sessionId)
          // 手机
          formData.append('Mobile', this.formDatas.mobile)
          // 验证码 api
          Axios.post(`${this.$api.root}/Developer/GetVerificationCode`, formData, {
            // 设置请求为表单提交
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((response) => {
            // http 请求成功
            if (response.status === 200) {
              // 获取接口数据
              let res = response.data

              switch (res.Code) {
                // 验证码申请成功，开始验证码倒计时
                case 0:
                  this.getCodeTime()
                  // 清空验证码错误提示
                  this.codeErrorTips = ''
                  break
                // 登录信息失效，删除登录信息跳转到登录页
                case 1:
                  delUserCookie()
                  this.$router.push({name: 'login'})
                  break
                // 记录错误提示信息
                case 2:
                  this.codeErrorTips = res.Msg
                  break
                // 清除用户登录信息并清空验证码提示信息
                default:
                  this.codeErrorTips = ''
                  delUserCookie()
                  this.$router.push({name: 'login'})
              }
            }
            // 请求接口失败
          }).catch((error) => {
            // 打印请求失败信息
            console.log(error)
          })
        }
      },
      // 发送短信验证码倒计时
      getCodeTime () {
        if (!this.codeTimer) {
          this.codeTimeCount = TIME_COUNT
          this.sendCodeshow = false
          this.codeTimer = setInterval(() => {
            if (this.codeTimeCount > 0 && this.codeTimeCount <= TIME_COUNT) {
              this.codeTimeCount--
            } else {
              this.sendCodeshow = true
              clearInterval(this.codeTimer)
              this.codeTimer = null
            }
          }, 1000)
        }
      }
    },
    components: {
      'v-developer-header': developerHeader
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developerInfo.styl";
</style>



// WEBPACK FOOTER //
// src/views/developerInfo/developerInfo.vue